import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle="This page doesn't exist. Head home and keep going."
      extra={
        <Button type="primary" onClick={() => navigate("/home")}>
          Back to Home
        </Button>
      }
    />
  );
}

export default NotFoundPage;
